import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/preregister.css";
import { Link } from "react-router-dom";
import { postJson } from "../network/api";
import { ApiEndpoints } from "../network/config";
import leftImage from "../assets/landing1.png";


const RegisterPhonenumber = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const handleGetOTP = async (e) => {
  e.preventDefault();

  if (!mobileNumber.trim()) {
    alert("Please enter your mobile number");
    return;
  }

  if (!/^\d{10}$/.test(mobileNumber)) {
    alert("Please enter a valid 10-digit mobile number");
    return;
  }

  try {
    const result = await postJson(ApiEndpoints.registration, {
      mobileNumber: mobileNumber.trim(),
    });

    console.log("Registration API Success:", result);

    setShowPopup(true);

    setTimeout(() => {
      setShowPopup(false);
      navigate("/otpregister", {
        state: {
          mobileNumber: mobileNumber,
          purpose: "registration",
        },
      });
    }, 2000);

  } catch (error) {
    console.error("API Error:", error);
    alert("Failed to send OTP. Please try again.");
  }
};


  const handleRegister = () => {
    navigate("/create-account");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleGetOTP(e);
    }
  };

  return (
    <div className="forgot-page">
      {/* Popup Message - Updated to card style */}
      {showPopup && (
        <div className="popup-message">
          <div className="popup-card-content">
            <div className="popup-icon">✓</div>
            <div className="popup-text">
              <p className="popup-title">OTP Sent Successfully!</p>
              <p className="popup-subtitle">
                OTP has been sent to {mobileNumber}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Left Image Section */}
      <div className="left-side">
        <img src={leftImage} alt="Lingayath Weds" className="left-image" />
      </div>

      {/* Right Forgot Password Section */}
      <div className="right-side">
        <div className="forgot-card">
          <h1 className="title">Welcome to Lingayath Weds</h1>
          <p className="note">
            <b>Note:</b> If you already have an account, please log in. <br />
            
          </p>

         
          

          <form onSubmit={handleGetOTP}>
            <div className="form-group">
              <label className="input-label">Mobile Number*</label>
              <input
                type="text"
                placeholder="Enter Mobile Number"
                className="form-input"
                value={mobileNumber}
                onChange={(e) =>
                  setMobileNumber(e.target.value.replace(/\D/g, ""))
                }
                onKeyPress={handleKeyPress}
                maxLength="10"
              />
            </div>

            <button type="submit" className="otp-btn">
              Get OTP
            </button>
          </form>

          

         
        </div>
      </div>
    </div>
  );
};

export default RegisterPhonenumber;
